import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { splitIssueText } from '../../lib/issue-mgmt-format.js';

/**
 * 課題・声の文を出す。伏せ字は灰色の小さな札にし（マウスを載せると説明）、検索語に当たった部分に色を付ける。
 *
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 課題や声の文を、伏せ字を札にして本文と見分けられるようにし、検索語に当たった部分に色を付けて表示する
 * @graph-connects splitIssueText [calls] 伏せ字と検索語で区切る
 */
export function IssueText({ text, query = '' }: { text: string; query?: string }) {
  const { t } = useTranslation();
  return (
    <>
      {splitIssueText(text, query).map((segment, index) => {
        const key = `${String(index)}-${segment.text}`;
        if (segment.mask) {
          return (
            <span
              key={key}
              title={t('issueMgmt.mask.tooltip')}
              className="mx-0.5 inline-block rounded bg-[var(--color-bg-muted)] px-1 text-[11px] leading-5 text-[var(--color-text-muted)]"
            >
              {segment.text}
            </span>
          );
        }
        if (segment.hit) {
          return (
            <mark
              key={key}
              className="rounded bg-[color-mix(in_srgb,var(--color-warning)_30%,transparent)] px-0.5 text-inherit"
            >
              {segment.text}
            </mark>
          );
        }
        return <Fragment key={key}>{segment.text}</Fragment>;
      })}
    </>
  );
}
